import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';

export default function Transactionhistory({ data, labels }) {
  useEffect(() => {
    const options = {
      series: [
        {
          name: 'Transactions',
          data: data, // Use passed data dynamically
        },
      ],
      chart: {
        type: 'area',
        height: 180,
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        colors: ['#FFFFD9'],
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          type: 'vertical',
          gradientToColors: ['#3D37F100'],
          stops: [0, 100],
        },
      },
      title: {
        text: 'Transaction History',
        align: 'left',
        style: {
          color: 'white', // Title color
        },
      },
      labels: labels, // Use passed labels dynamically
      xaxis: {
        type: 'category',
        labels: {
          style: {
            colors: 'white', // X-axis labels color
          },
        },
        axisBorder: {
          color: 'white', // X-axis border color
        },
        axisTicks: {
          color: 'white', // X-axis ticks color
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: 'white', // Y-axis labels color
          },
        },
        axisBorder: {
          color: 'white', // Y-axis border color
        },
        axisTicks: {
          color: 'white', // Y-axis ticks color
        },
      },
      legend: {
        horizontalAlign: 'left',
        labels: {
          colors: 'white', // Legend text color
        },
      },
    };

    const chart = new ApexCharts(document.querySelector('#transaction-chart'), options);
    chart.render();

    // Cleanup on unmount
    return () => {
      chart.destroy();
    };
  }, [data, labels]); // Re-run when data or labels change

  return (
    <div className='text-black text-center border border-[#ECEEF6] bg-[#1E1E1E] rounded-2xl px-5 py-3'>
      <div id="transaction-chart"></div>
    </div>
  );
}
